import React, { useState, useContext, useEffect } from 'react';

import { Button, InternalLink } from 'ctm-components';
import classNames from 'classnames';
import { createUseStyles } from 'react-jss';
import { connect } from 'react-redux';
import { quoteFormSelector } from 'ctm-selectors';
import { pageContext } from 'ctm-util-functions';

const useStyles = createUseStyles(() => ({
    container: {
        display: 'flex',
        justifyContent: 'center',
        paddingBottom: '2rem',
        '& button:first-of-type': {
            marginRight: '1rem'
        },
        '& span': {
            width: '47.5%',
            flex: 'none',
            '& button': {
                height: 'inherit',
                width: 'inherit',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                fontStyle: '400',
                lineHeight: '1.2',
                boxShadow: '0px 0.3rem 0.8rem rgba(0,0,0,0.2)',
                borderRadius: '0.4rem',
                padding: '1.6rem',
                fontWeight: '700',
                color: '#0b60b7',
                background: '#FFFFFF'
            }
        }
    },

    buttonStyling: ({ isXS }) => ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: isXS ? '16rem' : '30.5%',
        height: '5rem',
        borderRadius: '8px',
        textAlign: 'center',
        border: '1px solid #1C3E94',
        fontWeight: '700'
    }),
    active: {
        backgroundColor: '#008284',
        color: '#fff',
        border: 'none'
    },
    inactive: {
        backgroundColor: '#fff',
        color: '#1c3e94',
        textDecorationColor: '#fff'
    }
}));
const _ManualVehicleLookup = (props) => {
    const isXS = pageContext.getProps().pageState.breakpoint === 'xs';

    const classes = useStyles({ isXS });
    const {  currentIsManual, setJourneyAsManualLookup, setJourneyAsRegoLookup } = props;
    return (
        <div>
            <div className={classNames(classes.container)}>
                <Button
                    id="mvl_car_rego"
                    variant="secondary"
                    data-id="mvl_car_rego_button"
                    className={ classNames(classes.buttonStyling, currentIsManual ? classes.inactive : classes.active)}
                    onClick={() => {
                        setJourneyAsRegoLookup();
                    }}
                >
                    Registration number
                </Button>
                <InternalLink
                    id="mvl_car_manual"
                    data-id="mvl_car_manual_lookup"
                    href="/car-insurance/journey/car_make"
                    className={ classNames(classes.buttonStyling, currentIsManual ? classes.active : classes.inactive)}
                    onClick={() => {
                        setJourneyAsManualLookup();
                    }}
                >
                    Manual lookup
                </InternalLink>
            </div>
        </div>
    );
};

/**
 * mapStateToProps - sets up the rules required by this component
 * @param {Object} dispatch - Redux store state.
 * @return {Object} - The state attributes to add to props.
 */

const mapDispatchToProps = (dispatch) => ({
    setJourneyAsManualLookup: () => {
        dispatch({
            type: 'SET_PAGE_VALUE',
            value: true,
            stateKey: 'page',
            identifier: 'isManual'
        });
        dispatch({
            type: 'SET_VALUE',
            value: '',
            stateKey: 'vertical.quote',
            identifier: 'helpers.regoLabel'
        });
    },
    // Set isManual as false
    setJourneyAsRegoLookup: () => {
        dispatch({
            type: 'SET_PAGE_VALUE',
            value: false,
            stateKey: 'page',
            identifier: 'isManual'
        });
    }
});

const mapStateToProps = (state) => {
    const currentIsManual = state.getIn(['page', 'isManual']);
    return { currentIsManual };
};

const ManualVehicleLookup = connect(
    mapStateToProps,
    mapDispatchToProps
)(_ManualVehicleLookup);

export { ManualVehicleLookup };
